import { ProcessStepModeSchema, ProcessStep } from "../types";
import { computeProcessTime } from "./computeProcessTime";

type Params = {
  processStep: ProcessStep;
  quantity: number;
  quantityInAssembly: number | null;
  reworkRatio: number | null;
};

export const computeMachineCost = ({
  processStep,
  quantity,
  quantityInAssembly,
  reworkRatio,
}: Params) => {
  if (processStep.mode === ProcessStepModeSchema.enum.PREDICTION) {
    return {
      processTime: 0,
      machineCost:
        (processStep.cycleTimeCost || 0) * quantity + (processStep.machinePreparationTimeCost || 0),
      productionPace: 0,
    };
  }

  const { processTime } = computeProcessTime({
    reworkRatio: reworkRatio,
    totalQuantity: quantity * (quantityInAssembly ?? 1),
    processStep,
  });

  const machinePricePerMinute = (processStep.machineHourlyPrice ?? 0) / 60;
  const machineCost = processTime * machinePricePerMinute;

  const processTimeWithoutMachinePreparationTime =
    processTime - (processStep.machinePreparationTime || 0);

  let productionPace = 0;

  const isControlProcess = processStep.industrialProcess === "CONTROL";
  const isPackingProcess = processStep.industrialProcess === "PACKING";
  const isAssemblingProcess = processStep.industrialProcess === "ASSEMBLING";

  if (isControlProcess || isPackingProcess) {
    productionPace = processStep.manTime ? 1 / processStep.manTime : 0;
  } else if (isAssemblingProcess) {
    productionPace = processStep.manTime
      ? (1 * (processStep.isFixedCostPerSeries ? quantity : 1)) / processStep.manTime
      : 0;
  } else if (processTimeWithoutMachinePreparationTime) {
    productionPace = quantity / processTimeWithoutMachinePreparationTime;
  } else if (processStep.manTime) {
    productionPace = quantity / processStep.manTime;
  } else {
    productionPace = 0;
  }

  return {
    processTime,
    machineCost,
    productionPace,
  };
};
